import { UPDATE_REWARDS_VIEW } from './types';


export function RewardsViewReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_REWARDS_VIEW:
            return {
                ...state,
                rewardsViewData: payload
            }
        default:
            break;
    }

} 